import { Controller } from "@hotwired/stimulus";
import { requestLocation } from "../lib/geolocation";

// Fills hidden latitude/longitude inputs the first time the user interacts
// with the form (data-action="focusin->geolocation#locate").
export default class extends Controller {
  static targets = ["latitude", "longitude"];

  locate() {
    if (this.requested) return;
    this.requested = true;

    requestLocation(({ latitude, longitude }) => {
      this.latitudeTarget.value = latitude;
      this.longitudeTarget.value = longitude;
    });
  }
}
